import clsx from "clsx";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";

import { useCurrentUser } from "../../hooks/useCurrentUser";

import { BadgeCounter, BadgeCounterProps } from "./BadgeCounter";

const useStyles = makeStyles((theme) => ({
  root: {},
}));

export interface UnreadMessagesCounterProps
  extends Omit<BadgeCounterProps, "counter"> {}

export function UnreadMessagesCounter(props: UnreadMessagesCounterProps) {
  const { className, ...other } = props;
  const s = useStyles();
  const user = useCurrentUser();
  const counter = user?.unreadMessagesCount;

  return (
    <BadgeCounter
      className={clsx(s.root, className)}
      counter={counter}
      {...other}
    />
  );
}
